import { DEFAULT_VAT_RATE } from '../../atoms/vat-rate/vat-rate.atom';
import { VatRate } from '../../domain/VatRate';

// Who buys without VAT, the same as the backend's customer-vat.util:
// everyone pays the delivery country's rate, except a company that gives a
// VAT code and delivers outside Lithuania (the seller's country). The
// lllparts company rule is parked for now (decision 2026-10-21).
export const VAT_SALE_COUNTRY = 'LT';

export type VatBuyer = {
  isCompany?: boolean | null;
  vatCode?: string | null;
};

export const isVatExemptCompany = (
  country?: string | null,
  buyer?: VatBuyer,
): boolean =>
  !!buyer?.isCompany &&
  !!buyer.vatCode?.trim() &&
  (country ?? '').toUpperCase() !== VAT_SALE_COUNTRY;

export const getVatRate = (
  vatRates: VatRate[],
  country: string | undefined,
  buyer?: VatBuyer,
): VatRate => {
  const foundVatRate = vatRates?.find((vatRate) => vatRate.country === country);

  if (isVatExemptCompany(country, buyer) || !foundVatRate) {
    return { country: country ?? DEFAULT_VAT_RATE.country, rate: 0 };
  }

  return foundVatRate;
};

export const calculatePriceWithVat = (
  price: number,
  currentVatRate: VatRate | null,
): number => {
  const rate = currentVatRate ? currentVatRate.rate : DEFAULT_VAT_RATE.rate;
  const vatAmount = price * (rate / 100);

  return price + vatAmount;
};

// What a gross amount (VAT included at vatRate) holds as VAT.
export const getIncludedVat = (gross: number, vatRate: number): number =>
  vatRate > 0 ? (gross * vatRate) / (100 + vatRate) : 0;
